import { useAppSelector } from "../stores";
import { selectAllIssues } from '../stores/api'

const useCountIssues = (count: number) => {
    const issues = useAppSelector(selectAllIssues)

    return issues.slice(0, count)
};

export default useCountIssues